// extracted by mini-css-extract-plugin
module.exports = {"carouselBase":"styles_carouselBase__I_xLv","carousel":"styles_carousel__B5gs3","pagination":"styles_pagination__hx76F"};